<template lang="pug">
  .modal-mask.column.center.middle
    button.close-button.self-end(type='button' @click='closeModal')
      img(:src='closeIcon' alt='close')
    iframe.video(height='100%' width='100%' :src='catalogueUrl' v-on-clickaway='closeModal')
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway'
import closeIcon from '@/assets/ic_cross.svg'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      closeIcon
    }
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.viewCatalogueModal.props,
      locale: state => state.behavior.locale
    }),
    catalogueUrl() {
      return process.env[`VUE_APP_CATALOGUE_${this.locale}`]
    }
  },
  methods: {
    ...mapActions([ 'hideElement' ]),
    closeModal() {
      this.hideElement({ element: 'viewCatalogueModal' })
    }
  },
  mixins: [ clickaway ]
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $black-translusent;
  display: flex;
  transition: opacity .3s ease;
  z-index: 80;
}
.video {
  max-height: 664px;
  max-width: 1180px;
  border: 0;
}
.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  img {
    filter: invert(1);
    width: 25px;
    height: 25px;
  }
}
</style>
